<template>
  <main>
    <Header
        buttonTitle=""
        title="Perguntas Frequentes"
        text="Perguntas Frequentes"
        @action2="goToRoute('/perguntasFrequentesCadastrar')"
        :haveAction="false"
        :haveBack="true"
        @voltar="goToRoute()"
        :haveCustomButton="false"
    />

    <v-card class="mx-1">
      <v-row cols="12" class="pt-3 mx-1">
        <v-col
            xs="12"
            sm="12"
            md="8"
            lg="8"
            xl="8"
            class="pa-0 ma-0 pr-2"
        >
          <v-text-field
              outlined
              placeholder="Pesquisar perguntar frequentes"
              v-model="filter.search"
              :loading="loading"
          >
          </v-text-field>
        </v-col>

        <v-col
            xs="12"
            sm="12"
            md="4"
            lg="4"
            xl="4"
            class="pa-0 ma-0 d-flex justify-space-between"
        >
          <v-btn
              outlined
              tile
              width="49%"
              style="border-radius: 6px; font-size: 14px"
              small
              height="56"
              @click="list()"
          >
            <v-icon color="#bc0000" size="35">mdi-magnify</v-icon>
            Pesquisar
          </v-btn>

          <v-btn
              outlined
              tile
              style="border-radius: 6px; font-size: 14px"
              small
              height="56"
              width="49%"
              @click="reset()"
          >
            <v-icon color="#bc0000" size="35">mdi-refresh</v-icon>
            Limpar
          </v-btn>
        </v-col>
      </v-row>

      <v-row cols="12" style="margin-top: -20px">
        <v-col cols="12">
          <v-expansion-panels
              class="elevation-0"
              v-model="panel"
              multiple
          >
            <v-expansion-panel
                v-for="(item,i) in commonQuestions"
                :key="i"
                class="mb-1"
            >
              <v-expansion-panel-header
                  class="question"
                  color="#bc0000"
              >
                {{ item.question }}
                <template v-slot:actions>
                  <v-icon
                      color="#FFFFFF"
                      size="25"
                  >
                    mdi-chevron-up
                  </v-icon>
                </template>
              </v-expansion-panel-header>

              <v-expansion-panel-content color="pt-2">
                {{ item.answer }}
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <section class="ma-0 pa-0 px-1">
            <Pagination
                v-if="filter.totalItems > filter.pageSize"
                :currentPage="filter.currentPage"
                :totalItems="filter.totalItems"
                :page="filter.page"
                :pageSize="filter.pageSize"
                :totalPages="filter.totalPages"
                @back-page="backPage"
                @next-page="nextPage"
            >
            </Pagination>
          </section>
        </v-col>
      </v-row>
    </v-card>
  </main>
</template>

<script lang="js">
import ApiService from '../../../../services/ApiService';
import Header from "./../components/Header";
import Vue from "vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "CommonQuestionsResale",
  components: {
    Pagination,
    Header,
  },
  created() {

  },
  async mounted() {
    try {
      await this.list()
    } catch (e) {

    }
  },
  data() {
    return {
      loading: false,
      panel: [],
      apiService: new ApiService(),
      filter: {
        search: '',
        pageSize: 15,
        currentPage: 15,
        page: 1,
        totalPages: 1,
        totalItems: 1,
      },
      commonQuestions: [],
      totalItems: 0,
      currentCommonQuestions: null,
      deleteDialog: false,
      status: [
        {label: "Inativo", value: false},
        {label: "Ativo", value: true},
      ],
    }
  },

  methods: {
    async goToRoute() {
      await this.$router.go(-1);
    },
    async reset() {
      this.filter.search = '';
      this.filter.pageSize = 15;
      this.filter.page = 1;
      this.filter.totalPages = 1;
      await this.list()
    },

    async list() {
      this.loading = true;
      this.apiService.post('commonQuestions/all', this.filter).then((response) => {
        const {content} = response
        this.commonQuestions = content.commonQuestions
        this.filter.totalPages = content.pager.totalPages
        this.filter.totalItems = content.pager.totalItems
        this.filter.currentPage = content.pager.currentPage
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },
    async backPage() {
      this.filter.page -= 1;
      await this.list();
    },

    async nextPage() {
      this.filter.page += 1;
      await this.list();
    },

  },



  watch: {}
};
</script>

<style scoped>
.question {
  color: #FFFFFF;
  font-size: 16px;
}

</style>
